import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import { SEARCHBOX_INPUT_LENGTH } from '../../../config/consts';

import ddStyles from './index.scss';
import styles from './SeDropdownSearchInput.scss';

class SeDropdownSearchInput extends Component {
    handleKeydown = e => {
        // ESC
        if (e.keyCode === 27) {
            this.props.onChange('');
            this.props.onClose();
        }
    };

    handleChange = e => {
        this.props.onChange(e.target.value);
    };

    handleSearchClearClick = e => {
        this.props.onChange('');
        this.searchInput.focus();
        e.stopPropagation();
    };

    componentDidMount() {
        this.searchInput.focus();
    }

    render() {
        const {
            value,
            intl: { formatMessage },
            searchPlaceholder,
        } = this.props;

        const showClearSearch = !!value;

        const ddBtnClearSearch = classNames({
            [ddStyles.ddBtn]: true,
            [styles.searchInputClearBtn]: true,
        });

        return (
            <div className={styles.searchInputWrap}>
                <input
                    ref={el => {
                        this.searchInput = el;
                    }}
                    maxLength={SEARCHBOX_INPUT_LENGTH}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeydown}
                    type="text"
                    value={value}
                    className={styles.searchInput}
                    placeholder={formatMessage({ id: searchPlaceholder })}
                />
                {showClearSearch ? <button onClick={this.handleSearchClearClick} className={ddBtnClearSearch} /> : null}
            </div>
        );
    }
}

SeDropdownSearchInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }),
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func,
};
SeDropdownSearchInput.defaultProps = {
    onClose: () => {},
    className: '',
};

// eslint-disable-next-line
SeDropdownSearchInput = injectIntl(SeDropdownSearchInput);

export default SeDropdownSearchInput;
